module.exports = __webpack_public_path__ + "static/media/water.c2effc19.jpg";